<template>
  <div class="wrapper">
    <!-- <span id="loading"><img class="tbm-loader" :src="require('../assets/img/tbm_loader.gif')"></span> -->
    <div class="animated fadeIn">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
      <b-col sm="6">
        <b-card>
          <div slot="header">
            <strong>Customer (Dealer/Kios) </strong>
          </div>

          <b-row> <!-- Customer ID -->
            <!-- <b-col sm="12">
              <b-form-group>
                <label for="customer_id">Customer ID</label>
                <b-form-input v-model="form.customer_id" :state="customerIDState" type="text" id="customer_id" trim disabled></b-form-input>
              </b-form-group>
            </b-col> -->
          </b-row>

          <b-row> <!-- Kios Name -->
            <b-col sm="12">
              <b-form-group>
                <label for="kios_name">Customer Name (Dealer/Kios)</label>
                <b-form-input v-model="form.kios_name" :state="kiosNameState" type="text" id="kios_name" aria-describedby="input-live-help-kiosname input-live-feedback-kiosname" placeholder="Enter customer name" trim></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-kiosname">
                  Enter at least 1 letter
                </b-form-invalid-feedback>
                <b-form-text id="input-live-help-kiosname">Customer name (Dealer/Kios).</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12"> <!-- Position / Role -->
              <b-form-group>
                <label for="customer_type">Customer Type</label>
                <multiselect @remove="removeCustomerType" id="customer_type" v-model="customerTypeValue" :state="customerTypeState" :options="customerTypeOptions" :custom-label="nameWithLang" placeholder="-- Select Customer Type" label="id" track-by="id"></multiselect>
                <b-form-invalid-feedback :state="customerTypeState">Please select one</b-form-invalid-feedback>
                <b-form-valid-feedback :state="customerTypeState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row> <!-- Status Active -->
            <b-col sm="12">
              <b-form-group
                label="Customer Status (Dealer/Kios)"
                label-for="status"
                :label-cols="12"
                >
                <c-switch v-model="form.status" class="mx-1" color="primary" checked label />
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group>
            <label for="address">Customer Address</label>
            <b-form-textarea v-model="form.address" :state="addressState" type="text" id="customer_address" placeholder="Enter customer address" aria-describedby="input-live-help-address input-live-feedback-address" trim ></b-form-textarea>
            <b-form-invalid-feedback id="input-live-feedback-address">
              {{ invalidAddress }}
            </b-form-invalid-feedback>
            <b-form-text id="input-live-help-address">Customer address.</b-form-text>
          </b-form-group>
          <b-form-group>
            <label for="province" class="typo__label">Customer Province</label>
            <multiselect @input="getCities(1)" @remove="removeProvince(1)" id="customer_province" :state="provinceState" v-model="provinceValue" :options="provinceOptions" :custom-label="nameWithLang" placeholder="-- Select Province" label="id" track-by="id" :disabled="isProvinceDisable"></multiselect>
            <b-form-invalid-feedback :state="provinceState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="provinceState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
            <!-- {{ provinceValue }} -->
          </b-form-group>
          <b-form-group>
            <label for="city">Customer City</label>
            <multiselect @input="getDistricts(1)" id="customer_city" :state="cityState" v-model="cityValue" :options="cityOptions" :custom-label="nameWithLang" placeholder="-- Select City" label="id" track-by="id" :disabled="isCityDisable"></multiselect>
            <b-form-invalid-feedback :state="cityState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="cityState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
          </b-form-group>
             <b-form-group>
                <label for="district">Customer District</label>
                <multiselect @input="getVillages(1)" id="customer_district" :state="districtState" v-model="districtValue" :options="districtOptions" :custom-label="nameWithLang" placeholder="-- Select District" label="id" track-by="id" :disabled="isDistrictDisable"></multiselect>
                <b-form-invalid-feedback :state="districtState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="districtState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
              </b-form-group>
          <b-form-group>
            <label for="village">Customer Village</label>
            <multiselect v-model="villageValue" id="customer_village" :state="villageState" :options="villageOptions" :custom-label="nameWithLang" placeholder="-- Select Village" label="id" track-by="id" :disabled="isVillageDisable"></multiselect>
            <b-form-invalid-feedback :state="villageState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="villageState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
          </b-form-group>

          <b-row> <!-- Latitude -->
            <b-col sm="12">
              <b-form-group>
                <label for="latitude">Latitude</label>
                <b-form-input v-model="form.latitude" id="latitude" :state="latitudeState" type="text" aria-describedby="input-live-help-latitude input-live-feedback-latitude" placeholder="Enter latitude" trim></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-latitude">
                  Enter a valid latitude
                </b-form-invalid-feedback>
                <b-form-text id="input-live-help-latitude">Customer latitude.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row> <!-- Longitude -->
            <b-col sm="12">
              <b-form-group>
                <label for="longitude">Longitude</label>
                <b-form-input v-model="form.longitude" id="longitude" :state="longitudeState" type="text" aria-describedby="input-live-help-longitude input-live-feedback-longitude" placeholder="Enter longitude" trim></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-longitude">
                  Enter a valid longitude
                </b-form-invalid-feedback>
                <b-form-text id="input-live-help-longitude">Customer longitude.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- <b-form-group>
            <label for="sales_maintain">Sales Maintain</label>
            <multiselect v-model="salesMaintainValue" id="select_salesmaintain" :state="salesMaintainState" :options="salesMaintainOptions" :custom-label="nameWithLang" placeholder="-- Select Sales Maintain" label="id" track-by="id" :disabled="isSalesMaintainDisable"></multiselect>
            <b-form-invalid-feedback :state="salesMaintainState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="salesMaintainState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
          </b-form-group> -->

          <b-row>
            <b-col sm="8">

            </b-col>

          </b-row>

        </b-card>
      </b-col>

      <b-col sm="6"> <!-- Owner Form -->
        <b-card>
          <div slot="header">
            <strong>Owner </strong>
          </div>
          <b-row> <!-- First Name -->
            <b-col sm="12">
              <b-form-group>
                <label for="first_name">Owner First Name</label>
                <b-form-input v-model="form.first_name" :state="firstNameState" type="text" id="owner_firstname" aria-describedby="input-live-help-firstname input-live-feedback-firstname" placeholder="Enter owner first name"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-firstname">
                  Enter at least 1 letter
                </b-form-invalid-feedback>
                <b-form-text id="input-live-help-firstname">Owner first name.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row> <!-- Last Name -->
            <b-col sm="12">
              <b-form-group>
                <label for="last_name">Owner Last Name</label>
                <b-form-input v-model="form.last_name" :state="lastNameState" type="text" id="owner_lastname" aria-describedby="input-live-help-lastname input-live-feedback-lastname" placeholder="Enter owner last name"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-lastname">
                  Enter at least 1 letter
                </b-form-invalid-feedback>
                <b-form-text id="input-live-help-lastname">Owner last name.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row> <!-- Email -->
            <b-col sm="12">
              <b-form-group>
                <label for="email">Owner Email</label>
                <b-form-input v-model="form.email" :state="emailValid" v-on:keyup="emailKeyUp" v-on:change="emailChange" type="email" id="owner_email" aria-describedby="input-live-help-email input-live-feedback-email" placeholder="Enter owner email address" trim></b-form-input>
                 <!-- This will only be shown if the preceding input has an invalid state -->
                <b-form-invalid-feedback id="input-live-feedback-email">
                  {{ invalidEmail }}
                </b-form-invalid-feedback>

                <!-- This is a form text block (formerly known as help block) -->
                <b-form-text id="input-live-help-email">Owner email address.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row> <!-- Phone -->
            <b-col sm="12">
              <b-form-group>
                <label for="phone">Owner Primary Phone</label>
                <b-form-input v-model="form.phone" :state="phoneState" id="owner_phone1" v-on:keydown="phoneKeyDown" type="tel" maxlength="13" aria-describedby="input-live-help-phone input-live-feedback-phone" placeholder="Enter owner primary phone number" trim></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-phone">
                  Enter owner primary phone number
                </b-form-invalid-feedback>

                <b-form-text id="input-live-help-phone">Owner primary phone number.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row> <!-- Phone 2 -->
            <b-col sm="12">
              <b-form-group>
                <label for="phone2">Owner Secondary Phone</label>
                <b-form-input v-model="form.phone2" :state="phone2State" type="tel" id="owner_phone2" v-on:keydown="phoneKeyDown" v-on:keyup="phone2KeyUp" maxlength="13" aria-describedby="input-live-help-phone2 input-live-feedback-phone2" placeholder="Enter owner secondary phone number" trim></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback-phone2">
                  {{ invalidPhone2 }}
                </b-form-invalid-feedback>

                <b-form-text id="input-live-help-phone2">Owner secondary phone number.</b-form-text>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <label for="owner_address">Owner Address</label>
            <b-form-textarea v-model="form.ownerAddress" :state="ownerAddressState" type="text" id="owner_address" placeholder="Enter owner address" aria-describedby="input-live-help-owneraddress input-live-feedback-owneraddress" trim ></b-form-textarea>
            <b-form-invalid-feedback id="input-live-feedback-owneraddress">
              {{ invalidOwnerAddress }}
            </b-form-invalid-feedback>
            <b-form-text id="input-live-help-owneraddress">Owner address.</b-form-text>
          </b-form-group>

          <b-form-group>
            <label for="owner_province" class="typo__label">Owner Province</label>
            <multiselect @input="getCities(2)" @remove="removeProvince(2)" id="owner_province" :state="ownerProvinceState" v-model="ownerProvinceValue" :options="ownerProvinceOptions" :custom-label="nameWithLang" placeholder="-- Select Province" label="id" track-by="id" :disabled="isOwnerProvinceDisable"></multiselect>
            <b-form-invalid-feedback :state="ownerProvinceState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="ownerProvinceState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
            <!-- {{ provinceValue }} -->
          </b-form-group>

          <b-form-group>
            <label for="owner_city">Owner City</label>
            <multiselect @input="getDistricts(2)" id="owner_city" :state="ownerCityState" v-model="ownerCityValue" :options="ownerCityOptions" :custom-label="nameWithLang" placeholder="-- Select City" label="id" track-by="id" :disabled="isOwnerCityDisable"></multiselect>
            <b-form-invalid-feedback :state="ownerCityState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="ownerCityState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
          </b-form-group>

          <b-form-group>
                <label for="owner_district">Owner District</label>
                <multiselect @input="getVillages(2)" id="owner_district" :state="ownerDistrictState" v-model="ownerDistrictValue" :options="ownerDistrictOptions" :custom-label="nameWithLang" placeholder="-- Select District" label="id" track-by="id" :disabled="isOwnerDistrictDisable"></multiselect>
                <b-form-invalid-feedback :state="ownerDistrictState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="ownerDistrictState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
          </b-form-group>

          <b-form-group>
            <label for="owner_village">Owner Village</label>
            <multiselect v-model="ownerVillageValue" id="owner_village" :state="ownerVillageState" :options="ownerVillageOptions" :custom-label="nameWithLang" placeholder="-- Select Village" label="id" track-by="id" :disabled="isOwnerVillageDisable"></multiselect>
            <b-form-invalid-feedback :state="ownerVillageState">Please select one</b-form-invalid-feedback>
            <b-form-valid-feedback :state="ownerVillageState"><i class="fa fa-check fa-lg"></i></b-form-valid-feedback>
          </b-form-group>

          <br><br><br><br>
        </b-card>
      </b-col>


      <b-col sm="6">
        <!-- <b-card>
          <div slot="header">
            <strong>Bank Account </strong>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
              <label for="payroll">Payroll</label>
              <b-form-input type="text" id="payroll" placeholder="Enter your payroll"></b-form-input>
            </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="bank_acc_no">Bank Account Number</label>
                <b-form-input type="text" id="bank_acc_no" placeholder="Enter your bank account number"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card> -->
        </b-col>
    </b-row>
      <b-row>
        <b-col sm="12" class ="mb-3">
          <router-link :to="{name: 'CustomerManagement'}"><b-button type="button" variant="danger" class="mr-2 mb-2">Cancel</b-button></router-link>
          <b-button type="reset" variant="danger" class="mr-2 mb-2">Reset</b-button>
          <b-button type="submit" variant="primary" class="mr-2 mb-2">Submit</b-button>
        </b-col>
      </b-row>
      </b-form>
    </div>
  </div>
</template>

<style>
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import axios from 'axios'
import { apiRouter } from '../router/api-routing.js'
import Multiselect from 'vue-multiselect'
import { isLoggedIn, getIdToken, removeToken, getDataToken, getHeaderToken } from '../user/token.js'
import { isEmailValid, stringOnly, tagPrevention } from '../shared/input-validation.js';
import $ from 'jquery'

export default {
  props: ['customer_id'],
  components: {
    cSwitch,
    Multiselect
  },
  data() {
    return {
      phone2State: false,
      form: {
        customer_id: '',
        kios_name: '',
        first_name: '',
        last_name: '',
        salutation: '',
        gender: '',
        email: '',
        phone: '',
        status: '',
        address: '',
        ownerAddress: '',
        username: '',
        password: '',
      },
      createNew: '',
      customerTypeValue: '',
      customerTypeOptions: [
          { id: 5, name: 'Dealer' },
          { id: 6, name: 'Kios' },
        ],
      provinceValue: '',
      provinceOptions: [],
      cityValue: '',
      cityOptions: [],
      districtValue: '',
      districtOptions: [],
      villageValue: '',
      villageOptions: [],
      salesMaintainValue: '',
      salesMaintainOptions: [],
      isProvinceDisable: true,
      isCityDisable: true,
      isDistrictDisable: true,
      isVillageDisable: true,
      isSalesMaintainDisable: true,

      ownerProvinceValue: '',
      ownerProvinceOptions: [],
      ownerCityValue: '',
      ownerCityOptions: [],
      ownerDistrictValue: '',
      ownerDistrictOptions: [],
      ownerVillageValue: '',
      ownerVillageOptions: [],
      isOwnerProvinceDisable: true,
      isOwnerCityDisable: true,
      isOwnerDistrictDisable: true,
      isOwnerVillageDisable: true,

      customerData: [],
      show: true,
      customerID: '',
      ownerID: '',
      password: '',
      existingEmail: '',
      emailValid: false,
      invalidEmail: 'Enter owner email address',
      isAddressValid: false,
      invalidAddress: 'Enter customer address',
      isOwnerAddressValid: false,
      invalidOwnerAddress: 'Enter owner address',
      existingPhone2: '',
      invalidPhone2: 'Enter owner secondary phone number'
    }
  },
  computed: {
    kiosNameState(){
      return Boolean(this.form.kios_name.length > 0)
    },
    firstNameState(){
      return Boolean(this.form.first_name.length > 0)
    },
    lastNameState(){
      return Boolean(this.form.last_name.length > 0)
    },
    salutationState(){
      return Boolean(this.form.salutation)
    },
    genderState(){
      return Boolean(this.form.gender)
    },
    emailState() {
        // const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
        // return emailRegex.test(this.form.email);
    },
    phoneState(){
      const phoneRegex = /^[0-9]{10,13}$/
      return phoneRegex.test(this.form.phone)
    },
    addressState: function() {
      this.isAddressValid = Boolean(this.form.address.length > 7)
      if (this.form.address == ''){
        this.invalidAddress = 'Enter customer address'
      } else if (!this.isAddressValid){
        this.invalidAddress = 'Customer address is invalid. Minimum 8 character.'
      } else {
      }

      return this.isAddressValid
    },
    ownerAddressState(){
      this.isOwnerAddressValid = Boolean(this.form.ownerAddress.length > 7)
      if (this.form.address == ''){
        this.invalidOwnerAddress = 'Enter owner address'
      } else if (!this.isOwnerAddressValid){
        this.invalidOwnerAddress = 'Owner address is invalid. Minimum 8 character.'
      } else {
      }

      return this.isOwnerAddressValid
    },
    customerTypeState(){ return Boolean(this.customerTypeValue) },
    provinceState(){ return Boolean(this.provinceValue) },
    cityState(){ return Boolean(this.cityValue) },
    districtState(){ return Boolean(this.districtValue) },
    villageState(){ return Boolean(this.villageValue) },
    // salesMaintainState(){ return Boolean(this.salesMaintainValue) },

    ownerProvinceState(){ return Boolean(this.ownerProvinceValue) },
    ownerCityState(){ return Boolean(this.ownerCityValue) },
    ownerDistrictState(){ return Boolean(this.ownerDistrictValue) },
    ownerVillageState(){ return Boolean(this.ownerVillageValue) },

    customerIDState(){},
    latitudeState(){},
    longitudeState(){}
  },
  created() {
    this.checkSession()
    //console.log("cust " + this.customer_id);
    this.invalidEmail = 'Enter owner email address'
    let $vm = this
    var success = true

    // console.log('customer_id', this.customer_id)
    if (this.customer_id == undefined || this.customer_id == ''){ //generate customer id or not
      this.createNew = true
      this.checkEmail()
      // this.generateCustomerID();
    } else {
      this.createNew = false
      success = this.getDataByCustomerID()
    }

    this.getProvinces()
    // this.getSalesMaintain()

    // if (success){
    //   success = this.getProvinces();
    //   if (success){
    //     success = this.get
    //   }
    // }

    if (!success){
      //route
    }

  },
  mounted() {

  },
  watch: {
    existingEmail(newVal, oldVal){
      // console.log('existing.email', newVal + oldVal)
      if(newVal){
        //CHECK INPUT EMAIL
        if (this.form.email == ''){
          this.emailValid = false
          this.invalidEmail = 'Enter owner email address'

        } else if (this.existingEmail!='' && this.existingEmail==this.form.email){
          this.emailValid = true
          // console.log('SKIP')
        }
        //this.$router.push({name: 'SalesManagement'});
      } else {}
    },
    existingPhone2(newVal, oldVal){
      // console.log('existing.phone2', newVal + oldVal)
      if(newVal){
        //CHECK INPUT EMAIL
        if (this.form.phone2 == ''){
          this.phone2State = false

        } else if (this.existingPhone2!='' && this.existingPhone2==this.form.phone2 && this.existingPhone2!=this.form.phone){
          this.phone2State = true
        }
      } else {
        this.phone2State = false
      }
    },
  },
  methods: {
    checkSession(){
      if(isLoggedIn() === 1){
      } else {
        this.$router.push({name: 'Login'});
      }
    },
    showLoading(){
       this.$swal({
        imageUrl: require('../assets/img/tbm_loader.gif'),
        imageWidth: 200,
        imageHeight: 200,
        background: 'none',
        imageAlt: 'Custom image',
        showConfirmButton: false
      }).then((result) => {
        // if (page == ''){
        // } else {
        //   this.$router.replace({name: page});
        // }
      });
    },
    nameWithLang ({ name, language }) {
      return `${name}`
    },
    phoneKeyDown: function(evt){
      evt = (evt) ? evt : window.event
      // console.log('_',evt)
      //var charCode = (evt.ke) ? evt.which : evt.keyCode
      if(evt.ctrlKey){
        if ([65,67].indexOf(evt.keyCode) +1){
        } else {
          evt.preventDefault()
        }
      } else if(evt.shiftKey){
        if (evt.keyCode == 35 || evt.keyCode == 36 || (evt.keyCode > 36 && evt.keyCode < 41)){
        } else {
          evt.preventDefault()
        }
      } else if ((evt.keyCode > 36 && evt.keyCode < 41) || (evt.keyCode > 47 && evt.keyCode < 58) || [8,9,35,36,46].indexOf(evt.keyCode) +1){
      } else {
        evt.preventDefault()
      }
    },

    phone2KeyUp: function(evt){
      evt = (evt) ? evt : window.event
      this.form.phone = tagPrevention(evt, this.form.phone, 1)

      if(!evt){
        this.phone2State = false
        return false
      }
      let input = evt.target.value

      let isValid = false
      const phoneRegex2 = /^[0-9]{10,13}$/
      // console.log('phoneRegex2', phoneRegex2.test(input))
      isValid = phoneRegex2.test(input)
      // console.log('isValid', isValid)

      let isUnique = false
      if (input != this.form.phone){
        isUnique = true
      } else {
        this.invalidPhone2 = 'Secondary phone number must be different with primary phone number'
      }
      let isPhone2Valid = isValid && isUnique
      this.phone2State = isPhone2Valid
    },
    emailKeyUp: function(evt){
      this.form.email = tagPrevention(evt, this.form.email, 2)
    },
    emailChange: function(evt){
      this.$emit("change", evt)
      // console.log("change", evt)
      // console.log('existing email',this.existingEmail)
      // console.log('input email',this.form.email)

      if (this.form.email == ''){
        this.emailValid = false
        this.invalidEmail = 'Enter owner email address'

      } else if (this.existingEmail!='' && this.existingEmail==this.form.email){
        this.emailValid = true

      } else {
        // console.log('checkingg....')
        const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
        if (emailRegex.test(this.form.email)){
          //this.checkAvailable(1, evt)
          this.emailValid = true
        } else {
          this.emailValid = false
          this.invalidEmail = 'Email format is invalid'
        }
      }


      // console.log('thisss', this.form.email)

      // if (this.form.email == '' || this.existingEmail == '') {
      //   this.emailValid = false
      // }
    },
    checkEmail(){
      if (this.form.email == ''){
        this.emailValid = false
        this.invalidEmail = 'Enter owner email address'

      } else if(this.existingEmail == this.form.email){
        this.emailValid = true

      } else {
        this.emailValid = false
        this.invalidEmail = 'Enter owner email address'
      }
    },
    modalError(errorMessage){
      this.modalOK(errorMessage, 'error','');
    },
    modalOK(message, buttonVariant, page){

      this.$swal({title: message, html:'',text: '',
          type: buttonVariant,
          showCancelButton: false,
          confirmButtonText: 'OK',
          confirmButtonColor: '#4DBD74',
          showCloseButton: false,
          showLoaderOnConfirm: true,
      }).then((result) => {
        if (page == ''){
        } else {
          this.$router.replace({name: page});
        }
      });
    },
    getProvinces(){

      this.removeProvince(1)
      this.removeProvince(2)
      let $vm = this
      axios.get(apiRouter().provinces, getHeaderToken())
        .then(function (response){
          //console.log(response);
          if(response.status === 200){
              //console.log("Get Provinces success");
              $vm.provinceOptions = response.data.data
              $vm.isProvinceDisable = false
              $vm.ownerProvinceOptions = response.data.data
              $vm.isOwnerProvinceDisable = false
              //console.log("PROVINCE " + $vm.provinceOptions);
              return true
          } else {
            return false
            //console.log("not 200");
          }
        })
        .catch(function (error) {
            return false
            //console.log(error);
        });
    },
    getCities(mode){
      // console.log('provId', provId + " adfsf " + this.provinceValue)
      this.removeCity(mode)
      let isSelected = false

      if (mode == 1) {
        if (this.provinceValue != null){
          isSelected = true
        } else {
          isSelected = false
        }
      } else {
        if (this.ownerProvinceValue != null){
          isSelected = true
        } else {
          isSelected = false
        }
      }

      if (isSelected){

        let $vm = this
        let provId

        provId = (mode == 1 ? this.provinceValue.id : this.ownerProvinceValue.id)
        // console.log('provId after', provId)

      // console.log('UPDATE CITY 2 ' + provId)
        axios.get(apiRouter().cities + provId, getHeaderToken())
        .then(function (response){
          // console.log(response);
          if(response.status === 200){

            if (mode == 1){
              $vm.cityOptions = response.data.data
              // console.log("CITY " + $vm.cityOptions)
              $vm.isCityDisable = false
            } else {
              $vm.ownerCityOptions = response.data.data
              $vm.isOwnerCityDisable = false
            }
          } else {
            // console.log("not 200")
          }
        })
        .catch(function (error) {
            this.$router.replace({name: 'CustomerManagement'});
            // console.log(error);
        });
      }
    },

    getDistricts(mode){
      this.removeDistrict(mode)
      let isSelected = false

      if (mode == 1) {
        if (this.cityValue != null){
          isSelected = true
        } else {
          isSelected = false
        }
      } else {
        if (this.ownerCityValue != null){
          isSelected = true
        } else {
          isSelected = false
        }
      }

      if (isSelected){

        let $vm = this
        let cityId
        cityId = mode == 1 ? this.cityValue.id : this.ownerCityValue.id

        // console.log('UPDATE DISTRICT  ' + cityId);
        axios.get(apiRouter().districts + cityId, getHeaderToken())
        .then(function (response){
          // console.log(response);
          if(response.status === 200){

            if (mode == 1){
              $vm.districtOptions = response.data.data;
              $vm.isDistrictDisable = false
              // console.log("CITY " + $vm.districtOptions);
            } else {
              $vm.ownerDistrictOptions = response.data.data;
              $vm.isOwnerDistrictDisable = false
            }

          } else {
            // console.log("not 200");
          }
        })
        .catch(function (error) {
            // console.log(error);
        });
      }
    },

    getVillages(mode){
      this.removeVillage(mode)
      let isSelected = false

      if (mode == 1) {
        if (this.districtValue != null){
          isSelected = true
        } else {
          isSelected = false
        }
      } else {
        if (this.ownerDistrictValue != null){
          isSelected = true
        } else {
          isSelected = false
        }
      }

      if (isSelected){
        let $vm = this
        let districtId
        districtId = mode == 1 ? this.districtValue.id : this.ownerDistrictValue.id

        // console.log('UPDATE VILLAGE ' + districtId);
        axios.get(apiRouter().villages + districtId, getHeaderToken())
        .then(function (response){
          // console.log(response)
          if(response.status === 200){

            if (mode == 1){
              $vm.villageOptions = response.data.data
              $vm.isVillageDisable = false
              // console.log("CITY " + $vm.villageOptions)
            } else {
              $vm.ownerVillageOptions = response.data.data
              $vm.isOwnerVillageDisable = false
            }

          } else {
            // console.log("not 200")
          }
        })
        .catch(function (error) {
            // console.log(error)
        });
      }
    },

    getSalesMaintain(){
      this.isSalesMaintainDisable = true
      this.salesMaintainValue = ''
      this.salesMaintainOptions = []
      let $vm = this


   axios.get(apiRouter().view_all_sales, getHeaderToken())
      .then(function (response){

        // console.log('sales maintain', response.data.data[0].sales_id)

        if(response.status === 200){
            let temp = []
            temp = response.data.data
            $vm.isSalesMaintainDisable = false

            for (var i=0; i<temp.length; i++){
              // console.log('sales maintain', response.data.data[i].sales_id)
              $vm.salesMaintainOptions.push({sales_id: temp[i].sales_id, name: temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].city_name +')'})
            }
            return true
            // console.log('SMO', $vm.salesMaintainOptions)
        } else {
          return false
          // console.log("not 200")
        }
      })
      .catch(function (error) {
        this.$router.replace({name: 'CustomerManagement'});
        return false
          // console.log(error);
      });

    },
    removeCustomerType({name, id}){
      // console.log('removeCustomerType VALUE', name)
      // console.log('removeCustomerType ID', id)
      this.customerTypeValue = ''
    },
    removeProvince(mode){
      this.provinceValue = ''
      this.ownerProvinceValue = ''
      // console.log('pv', this.ownerProvinceValue)
      this.removeCity(mode)
    },

    removeCity(mode){
      if (mode == 1){
        this.isCityDisable = true
        this.cityValue = ''
        this.cityOptions = []
      } else {
        this.isOwnerCityDisable = true
        this.ownerCityValue = ''
        this.ownerCityOptions = []
      }
      this.removeDistrict(mode);
    },

    removeDistrict(mode){
      if (mode == 1){
        this.isDistrictDisable = true
        this.districtValue = ''
        this.districtOptions = []
      } else {
        this.isOwnerDistrictDisable = true
        this.ownerDistrictValue = ''
        this.ownerDistrictOptions = []
      }
      this.removeVillage(mode);
    },

    removeVillage(mode){
      if (mode == 1){
        this.isVillageDisable = true
        this.villageValue = ''
        this.villageOptions = []
      } else {
        this.isOwnerVillageDisable = true
        this.ownerVillageValue = ''
        this.ownerVillageOptions = []
      }
    },

    onSubmit(evt) {
        evt.preventDefault()
        //alert(JSON.stringify(this.form));
        //+ 'province: ' + provinceValue + 'city: ' + cityValue + 'district: ' + districtValue + 'village: ' + villageValue

      const fill = "Please fill "
      const choose = "Please choose "

      if (this.form.kios_name == '') {$("#kios_name").focus(); return this.modalError(fill + 'Customer Name'); }
      if (this.customerTypeValue == '' || this.customerTypeValue == null) {$("#customer_type").select(); return this.modalError(choose + 'Customer Type'); }
      if (this.form.status == '') {return this.modalError(choose + 'Status')}
      if (this.form.address == '' || !this.isAddressValid) {$("#customer_address").focus(); return this.modalError(fill + 'Address')}
      if (this.provinceValue == '' || this.provinceValue == null) {$("#customer_province").select(); return this.modalError(choose + 'Province')}
      if (this.cityValue == '' || this.cityValue == null) {$("#customer_city").select(); return this.modalError(choose + 'City')}
      if (this.districtValue == '' || this.districtValue == null) {$("#customer_district").select(); return this.modalError(choose + 'District')}
      if (this.villageValue == '' || this.villageValue == null) {$("#customer_village").select(); return this.modalError(choose + 'Village')}
      // if (this.form.latitude == '') return alert(fill + 'latitude');
      // if (this.form.longitude == '') return alert(fill + 'longitude');
      // if (this.salesMaintainValue == '' || this.salesMaintainValue == null) {$("#select_salesmaintain").select(); return this.modalError(choose + 'Sales Maintain')}

      if (this.form.first_name == '') {$("#owner_firstname").focus(); return this.modalError(fill + 'Owner First Name')}
      if (this.form.last_name == '') {$("#owner_lastname").focus(); return this.modalError(fill + 'Owner Last Name')}
      // if (this.form.profile_picture == '') return alert(fill + 'owner profile picture');
      if (this.form.email == '' || !this.emailValid) {$("#owner_email").focus(); return this.modalError(fill + 'Owner Email', 'error','')}
      if (this.form.phone == '' || this.form.phone == null) {$("#owner_phone1").focus(); return this.modalError(fill + 'Primary Phone')}
      if (this.form.phone2 == '' || this.form.phone2 == null) {$("#owner_phone2").focus(); return this.modalError(fill + 'Secondary Phone')}
      // if (this.form.phone2 == '') return alert(fill + 'owner alternative phone');
      if (this.form.ownerAddress == '' || !this.isOwnerAddressValid) {$("#owner_address").focus(); return this.modalError(fill + 'Owner Address')}
      if (this.ownerProvinceValue == '' || this.ownerProvinceValue == null) {$("#owner_province").select(); return this.modalError(choose + 'Owner Province')}
      if (this.ownerCityValue == '' || this.ownerCityValue == null) {$("#owner_city").select(); return this.modalError(choose + 'Owner City')}
      if (this.ownerDistrictValue == '' || this.ownerDistrictValue == null) {$("#owner_district").select(); return this.modalError(choose + 'Owner District')}
      if (this.ownerVillageValue == '' || this.ownerVillageValue == null) {$("#owner_village").select(); return this.modalError(choose + 'Owner Village')}

      this.submitDataCustomer();
    },
    onReset(evt) {
      evt.preventDefault()
      //this.form.customer_id = this.form.customer_id;
      // Reset our form values

      this.form.kios_name = ''
      this.customerTypeValue = ''
      this.form.status = true
      this.form.address = ''
      this.provinceValue = ''
      this.cityValue = ''
      this.districtValue = ''
      this.villageValue = ''
      this.form.latitude = ''
      this.form.longitude = ''
      this.salesMaintainValue = ''

      this.form.first_name = ''
      this.form.last_name = ''
      this.form.email = ''
      this.emailValid = false
      this.invalidEmail = 'Enter owner email address'
      this.form.phone = ''
      this.phone2State = false
      this.form.phone2 = ''
      this.form.ownerAddress = ''
      this.ownerProvinceValue = ''
      this.ownerCityValue = ''
      this.ownerDistrictValue = ''
      this.ownerVillageValue = ''

      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      });
    },
    getDataByCustomerID(){ //edit data customer
      // console.log("cust" + this.customer_id)
      let $vm = this;
      //console.log("getData")
    axios.get(apiRouter().view_data_customer + this.customer_id, getHeaderToken())
        .then(response => {
          // console.log(response);
          //document.getElementById('testLoading').click();
          if(response.status === 200){
              //console.log("success");
              //this.customerData = response.data;
              // console.log('customer data', response.data)

              let r = response.data[0]
              $vm.customerID = r.id
              $vm.form.kios_name = r.kios_name

              let roleName;
              if (r.role_id == 5){
                roleName = 'Dealer';
              } else if (r.role_id == 6){
                roleName = 'Kios';
              }
              $vm.customerTypeValue = { id: r.role_id, name: roleName };

              $vm.form.address = r.address
              $vm.form.longitude = r.longtitude=='undefined' ? '': r.longtitude
              $vm.form.latitude = r.latitude=='undefined' ? '': r.latitude

              $vm.provinceValue = { id: r.province_id, name: r.province_name }
              $vm.cityValue = { id: r.city_id, name: r.city_name }
              $vm.districtValue = { id: r.district_id, name: r.district_name }
              $vm.villageValue = { id: r.village_id, name: r.village_name }
              // $vm.salesMaintainValue = { sales_id: r.sales_id, name: r.sales_name + ' (' + r.city_name + ')' }

              let isActive = r.status==1? true : false;
              $vm.form.status = isActive;

              let owner = r.data_owner[0]
              $vm.ownerID = owner.id
              $vm.form.first_name = owner.first_name
              $vm.form.last_name = owner.last_name
              //$vm.form.profile_picture = owner.profile_picture;
              $vm.form.phone = owner.no_handphone_1
              $vm.form.phone2 = owner.no_handphone_2
              $vm.existingPhone2 = owner.no_handphone_2
              $vm.form.email = owner.email
              $vm.existingEmail = owner.email
              $vm.form.ownerAddress = owner.address

              $vm.ownerProvinceValue = { id: owner.province_id, name: owner.province_name }
              $vm.ownerCityValue = { id: owner.city_id, name: owner.city_name }
              $vm.ownerDistrictValue = { id: owner.district_id, name: owner.district_name }
              $vm.ownerVillageValue = { id: owner.village_id, name: owner.village_name }

              this.checkEmail()

              //document.getElementById('loading').display = 'none'
              // $('#loading').hide;
            return true
          } else {
            return false
            // console.log("not 200");
          }
        })
        .catch(function (error) {
            this.$router.replace({name: 'CustomerManagement'});
            return false
            // console.log(error);
            //document.getElementById('testLoading').click();
        });


      //$('#loading').visible="hidden";
      //document.getElementById('loading').style.display="none";
    },
    createOwner(){
      //OWNER
          const fdOwner = new FormData();
          // fdOwner.append('owner_id', 1);
          fdOwner.append('owner_first_name', stringOnly(this.form.first_name))
          fdOwner.append('owner_last_name', stringOnly(this.form.last_name))
          fdOwner.append('profile_picture', "profile_picture.jpg")
          fdOwner.append('handphone_1', stringOnly(this.form.phone))
          fdOwner.append('handphone_2', stringOnly(this.form.phone2))
          fdOwner.append('email', stringOnly(this.form.email));
          fdOwner.append('address', stringOnly(this.form.ownerAddress))
          fdOwner.append('owner_province_id', this.ownerProvinceValue.id)
          fdOwner.append('owner_city_id', this.ownerCityValue.id)
          fdOwner.append('owner_district_id', this.ownerDistrictValue.id)
          fdOwner.append('owner_village_id', this.ownerVillageValue.id)

          // console.log('owner_first_name', this.form.first_name);
          // console.log('owner_last_name', this.form.last_name);
          // console.log('profile_picture', "profile_picture.jpg");
          // console.log('handphone_1', stringOnly(this.form.phone));
          // console.log('handphone_2', stringOnly(this.form.phone2));
          // console.log('email', this.form.email);
          // console.log('address', this.form.ownerAddress);
          // console.log('owner_province_id', this.ownerProvinceValue.id);
          // console.log('owner_city_id', this.ownerCityValue.id);
          // console.log('owner_district_id', this.ownerDistrictValue.id);
          // console.log('owner_village_id', this.ownerVillageValue.id);

          if (this.createNew){

            this.showLoading()
              axios.post(apiRouter().create_owner, fdOwner, getHeaderToken())
              .then(response => {
                this.$swal.close()
                  console.log('reessss',response);
                  // console.log('reessss data',response.data);
                  //document.getElementById('testLoading').click();
                if(response.status == 200){
                  // console.log('ya', response.data);
                  this.createCustomer(response.data);
                }
              })
              .catch(error => {
                this.$swal.close()
                // console.log(error);
              });

          } else { //update existing customer

              this.showLoading()
              axios.post(apiRouter().update_owner + this.ownerID, fdOwner, getHeaderToken())
              .then(response => {
                this.$swal.close()
                  // console.log(response);
                  //document.getElementById('testLoading').click();
                if(response.status == 200){
                  //console.log(response.data);
                  this.createCustomer(this.ownerID);

                }
              })
              .catch(error => {
                this.$swal.close()
                // console.log(error);
              });
          }
    },
    createCustomer(ownerID){
      // DEALER/KIOS
      // console.log('createCustomer', 'createCustomercalled ' + ownerID)
          const formData = new FormData();
          formData.append('kios_name', stringOnly(this.form.kios_name))
          formData.append('role_id', this.customerTypeValue.id)
          formData.append('address', stringOnly(this.form.address))
          formData.append('longitude', this.form.longitude==''? 0:this.form.longitude)

          // console.log('longitude', this.form.longitude)
          formData.append('latitude', this.form.latitude==''? 0:this.form.latitude)
          // console.log('latitude', this.form.latitude)
          formData.append('province_id', this.provinceValue.id)
          formData.append('city_id', this.cityValue.id)
          formData.append('district_id', this.districtValue.id)
          formData.append('village_id', this.villageValue.id);
          formData.append('status', this.form.status==true? 1:2)
          // formData.append('sales_id', this.salesMaintainValue.sales_id)
          // console.log('formdata', formData)
          if (this.createNew){
            formData.append('owner_id', ownerID);
            // console.log('owner_id', ownerID);
          } else {
            formData.append('owner_id', this.ownerID);
            // console.log('owner_id', this.ownerID);
          }

          // console.log('kios_name', this.form.kios_name.toString());
          // console.log('role_id', this.customerTypeValue.id.toString());
          // console.log('address', this.form.address.toString());
          // console.log('longitude', this.form.longitude.toString());
          // console.log('latitude', this.form.latitude.toString());
          // console.log('province_id', this.provinceValue.id.toString());
          // console.log('city_id', this.cityValue.id.toString());
          // console.log('district_id', this.districtValue.id.toString());
          // console.log('village_id', this.villageValue.id.toString());
          // console.log('status', this.form.status===true? "1" : "2");
          // console.log('sales_id', this.salesMaintainValue.sales_id.toString());

          if (this.createNew){
              axios.post(apiRouter().create_customers, formData, getHeaderToken())
              .then(response => {
                if(response.status == 200){
                  // console.log(response.data);
                  if(response.data.status == "200"){
                      this.modalOK(this.form.kios_name + ' added successfully', 'success','CustomerManagement');
                  } else {
                    this.modalOK('Add ' + this.form.kios_name + ' failed', 'error','');
                  }
                } else {
                  this.modalOK('Add ' + this.form.kios_name + ' failed', 'error','');
                }
              })
              .catch(function (error) {
                //console.log('error cust', error)
                  this.modalOK('Add ' + this.form.kios_name + ' failed', 'error','');
              });
          } else { //update existing customers
                axios.post(apiRouter().update_customers + this.customerID, formData, getHeaderToken())
              .then(response => {
                  // console.log('hasil',response);
                if(response.status == 200){
                  // console.log(response.data);
                  if(response.data.status == "200"){
                      this.modalOK(this.form.kios_name + ' updated successfully', 'success','CustomerManagement');
                  } else {
                    this.modalOK('Save data ' + this.form.kios_name + ' failed', 'error','');
                  }
                } else {
                  this.modalOK('Save data ' + this.form.kios_name + ' failed', 'error','');
                }
              })
              .catch(function (error) {
                //console.log('error cust', error)
                  this.modalOK('Save data ' + this.form.kios_name + ' failed', 'error','');
              });
          }
    },
    submitDataCustomer(){

      this.createOwner();
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
